import { gql } from "@apollo/client";

// Existing mutations
export const SIGN_UP = gql`
  mutation SignUp($companyInput: CompanyInput!, $userInput: UserInput!) {
    signUp(companyInput: $companyInput, userInput: $userInput) {
      company {
        id
        name
        users {
          id
          name
          email
        }
      }
      token
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        name
      }
    }
  }
`;

export const CREATE_LISTINGS = gql`
  mutation CreateListings($listings: [ListingInput!]!) {
    createListings(listings: $listings) {
      id
      shopifyProductId
      title
      body_html
      vendor
      product_type
      created_at
      handle
      updated_at
      published_at
      template_suffix
      published_scope
      tags
      status
      admin_graphql_api_id
      variants {
        id
        title
        sku
        price
        inventoryQuantity
        inventoryItemId
        productId
        images {
          id
          src
          altText
          position
        }
        option1
        option2
        option3
      }
      options {
        id
        name
        position
        values
      }
      images {
        id
        src
        altText
        position
      }
      image {
        id
        src
        altText
        position
      }
    }
  }
`;

// New addToCart mutation

export const CREATE_CART = gql`
  mutation CreateCart($items: [CartLineInput!]!) {
    createCart(items: $items) {
      id
      lines {
        id
        quantity
        merchandise {
          id
          title
          price
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export const ADD_TO_CART = gql`
  mutation AddToCart($cartId: ID!, $items: [CartLineInput!]!) {
    addToCart(cartId: $cartId, items: $items) {
      id
      lines {
        id
        quantity
        merchandise {
          id
          title
          price
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export const UPDATE_CART_ITEMS = gql`
  mutation UpdateCartItems($cartId: ID!, $items: [CartLineUpdateInput!]!) {
    updateCartItems(cartId: $cartId, items: $items) {
      id
      lines {
        id
        quantity
        merchandise {
          id
          title
          price
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export const REMOVE_FROM_CART = gql`
  mutation RemoveFromCart($cartId: ID!, $lineIds: [ID!]!) {
    removeFromCart(cartId: $cartId, lineIds: $lineIds) {
      id
      lines {
        id
        quantity
        merchandise {
          id
          title
          price
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export const DELETE_COMPANY_CONNECTION = gql`
  mutation DeleteCompanyConnection($shopDomain: String!) {
    deleteCompanyConnection(shopDomain: $shopDomain)
  }`;